<template>
  <div>
    <el-menu mode="horizontal"
             :default-active="$route.path"
             :unique-opened="false"
             background-color="#f4f4f5"
             text-color="black"
             active-text-color="#1890ff">
      <menu-item v-for="item of visibleMenu"
                 :key="item.path"
                 :item="item"
                 base-path="/"
                 :is-root="true">
      </menu-item>
    </el-menu>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import MenuItem from '@/layout/menu/MenuItem'

export default {
  name: 'HorizMenu',
  props: {
    menuList: Array
  },
  components: { MenuItem },
  methods: {
    filterRoutesDfs (routes) {
      const ret = routes.filter(route => !route.hidden)
      for (const item of ret) {
        if (item.children) {
          item.children = this.filterRoutesDfs(item.children)
        }
      }
      return ret
    }
  },
  computed: {
    ...mapGetters([
      'permission_routes'
    ]),
    visibleMenu () {
      // var menu = this.permission_routes.filter(route => !route.hidden)
      const menu = this.filterRoutesDfs(this.permission_routes)
      if (menu[2].name === 'Report') {
        var arr = menu[2].children
        if (this.menuList.length === 0) {
          return menu
        }
        for (var i = arr.length - 1; i >= 0; i--) {
          if (this.menuList.indexOf(arr[i].name) === -1) {
            arr.splice(i, 1)
          }
        }
        if (menu[2].children.length === 0) {
          menu.splice(2, 1)
        }
      }
      return menu
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ .el-menu.el-menu--horizontal {
  border-bottom: 0;
}
</style>
